import Cookies from "js-cookie";
import axios from "../config/axios";
import type { AuthUser, UserType } from "@/context/AuthContext";

interface LoginResponse {
    token: string;
    user: AuthUser;
}

export const loginUser = async (
    credentials: { email: string; password: string }
): Promise<LoginResponse> => {
    try {
        const response = await axios.post("/api/users/login", credentials);
        const { token, user } = response.data as LoginResponse;

        // store both user and token in cookies
        Cookies.set("authUser", JSON.stringify(user), { expires: 1 });
        Cookies.set("authToken", token, { expires: 1 });

        return { token, user };
    } catch (error: any) {
        throw error?.response?.data || error;
    }
};

export const signupUser = async (
    userData: { name: string; email: string; password: string; phone: string; company?: string; licenseNumber: string; userType: "BROKER" }
): Promise<LoginResponse> => {
    try {
        const response = await axios.post("/api/users/add-broker", userData);
        const { token, user } = response.data as LoginResponse;

        // store both user and token in cookies
        Cookies.set("authUser", JSON.stringify(user), { expires: 1 });
        Cookies.set("authToken", token, { expires: 1 });

        return { token, user };
    } catch (error: any) {
        throw error?.response?.data || error;
    }
};

export const logoutUser = async (): Promise<void> => {
    try {
        await axios.post("/api/users/logout");
    } catch {
        // even if backend fails, frontend should still log out
    }
};

export const getAdminUserStats = async () => {
    try {
        const response = await axios.get('/api/admin/AllUsersStats');
        return response.data;
    } catch (error: any) {
        throw error.response?.data || error;
    }
};

export const getAllUsers = async (filter: { [key: string]: any }) => {
    try {
        const response = await axios.get('/api/admin/AllUsers', {
            params: filter
        });
        return {
            data: response.data.data,
            pagination: response.data.pagination
        }
    } catch (error: any) {
        throw error.response?.data || error;
    }
};

export const updateUserStatus = async (userId: string, status: boolean) => {
    try {
        const response = await axios.put(`/api/admin/${userId}/status`, { status });
        return response.data;
    } catch (error: any) {
        throw error.response?.data || error;
    }
};

export const getUserById = async (userId: string) => {
    try {
        const response = await axios.get(`/api/users/${userId}`);
        return response.data;
    } catch (error: any) {
        throw error.response?.data || error;
    }
};
